import React from 'react';
import PropTypes from "prop-types";

import Button from "react-bootstrap/Button";

import { CustomContainer } from "components/atoms/DependencyHelper";
import LabelText from "components/atoms/label/LabelText";

import {
  imagePrefix,
} from "utils/helperServices";
import { useScreenType } from "utils/hooks/common";

import styles from "./DeviceSubsection.module.scss";

import { ScreenSizeTypes } from "../../../config/constants";

const DeviceSubsection = (props) => {
  const isDesktop = useScreenType() === ScreenSizeTypes.Desktop;
  const isTablet = useScreenType() === ScreenSizeTypes.Tablet;

  const renderFooterNotice = () => {
    if (isDesktop || !props.footerText) return null;

    return (
      <CustomContainer className={styles["device-subsection-footer"]}>
        { isTablet &&
          <img
            className={`${styles["footer--icon"]} ${open ? styles["open"] : ""}`}
            src={`${imagePrefix}/assets/images/info_white.svg`}
          />
        }

        <LabelText className={styles["footer--label"]}>
          { props.footerText }
        </LabelText>

        <Button onClick={props.onDismissFooter} variant="link">Dismiss</Button>
      </CustomContainer>
    );
  }

  return (
    <CustomContainer className={`col-sm-12 ${props.className} ${styles["device-subsection"]}`}>
      <CustomContainer className={styles["device-content"]}>
        { props.children }

        { renderFooterNotice() }
      </CustomContainer>
    </CustomContainer>
  );
}

DeviceSubsection.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  footerText: PropTypes.string,
  onDismissFooter: PropTypes.func,
};

DeviceSubsection.defaultProps = {
  className: "",
  footerText: "",
  onDismissFooter: () => null
};

export default DeviceSubsection;
